/* Header behaviour (sections/header.liquid type 2, snippets/popup-navigation.liquid).
   Loaded once from layout/theme.liquid after ac-cart.js.

   The theme keeps ownership of the header: sticky-header, the popup engine,
   search-ajax, the cart and wishlist counters (theme.Cart.updateCounter and
   theme.StoreLists updateHeaderCount write [data-js-cart-count-*] and
   [data-js-wishlist-count]) and theme.Position, which moves the nav into the
   drawer on phones. This adds:

   - nav classes: page links (About, Reviews) marked secondary with a
     separator before the first, and the current page marked active
   - badge care: counts over 99 read "99+" while the exact number stays in
     the control's accessible name; icon-only controls get names that carry
     the count without a live region
   - dialog semantics for the menu drawer and the account popup through the
     registry in ac-cart.js, the hamburger's aria-expanded, and focus on the
     drawer's search field when it was opened from the search trigger */
(function () {
  'use strict';

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---- nav classes ------------------------------------------------------- */

  function decorateNav() {
    var items = $all('.menu--main .menu__level-01 > .menu__item');
    if (!items.length) return;
    var path = window.location.pathname.replace(/\/$/, '') || '/';
    var sepDone = false;
    items.forEach(function (item) {
      var a = item.querySelector(':scope > a');
      if (!a) return;
      if (item.classList.contains('ac-hd-nav--soon')) return; /* unlinked "Coming soon" item: never active */
      var href = a.getAttribute('href') || '';
      var hrefPath = href.split(/[?#]/)[0].replace(/\/$/, '') || '/';
      var secondary = /\/pages\//.test(hrefPath);
      item.classList.toggle('ac-hd-nav--secondary', secondary);
      if (secondary && !sepDone) { item.classList.add('ac-hd-nav--sep'); sepDone = true; }
      var active = hrefPath === '/' ? path === '/' : (path === hrefPath || path.indexOf(hrefPath + '/') === 0);
      item.classList.toggle('ac-hd-nav--active', active);
      if (active) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
    });
  }

  /* ---- badges ------------------------------------------------------------ */

  var COUNTERS = '[data-js-wishlist-count], [data-js-cart-count-mobile]';

  function labelFor(counter, count) {
    var control = counter.closest('a, button');
    if (!control) return;
    var isCart = counter.hasAttribute('data-js-cart-count-mobile');
    var noun = count === 1 ? 'item' : 'items';
    var base = isCart ? 'Bag' : 'Saved designs';
    control.setAttribute('aria-label', base + ', ' + (count === 0 ? 'empty' : count + ' ' + noun));
  }

  function syncBadge(counter) {
    var attr = counter.hasAttribute('data-js-wishlist-count') ? 'data-js-wishlist-count' : 'data-js-cart-count-mobile';
    var count = parseInt(counter.getAttribute(attr), 10);
    if (isNaN(count)) count = 0;
    if (count > 99 && counter.textContent !== '99+') counter.textContent = '99+';
    counter.setAttribute('aria-hidden', 'true');
    labelFor(counter, count);
  }

  function watchBadges() {
    $all(COUNTERS).forEach(function (counter) {
      if (counter.__acHeader) return;
      counter.__acHeader = true;
      syncBadge(counter);
      new MutationObserver(function () { syncBadge(counter); }).observe(counter, { attributes: true, attributeFilter: ['data-js-wishlist-count', 'data-js-cart-count-mobile'], childList: true, characterData: true, subtree: true });
    });
  }

  /* ---- drawer: dialog semantics, hamburger state, search focus ------------ */

  var openedForSearch = false;
  document.addEventListener('click', function (event) {
    var t = event.target && event.target.closest && event.target.closest('[data-ac-hd-search-trigger]');
    openedForSearch = !!t;
  }, true);

  function bindPopups() {
    var t = window.theme;
    if (!t || !t.Popups || typeof t.Popups.addHandler !== 'function') return false;
    if (window.acDrawerDialog) {
      window.acDrawerDialog.register('navigation', { root: '.popup-navigation', close: '.popup-navigation__close' });
      window.acDrawerDialog.register('account', { root: '.popup-account', close: '.popup-account__close' });
    }
    t.Popups.addHandler('navigation', 'call.after', function () {
      $all('.header__btn-menu').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (openedForSearch) {
        openedForSearch = false;
        var input = document.querySelector('.popup-navigation input[name="q"]');
        if (input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
      }
    });
    t.Popups.addHandler('navigation', 'close.before', function () {
      $all('.header__btn-menu').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
    return true;
  }

  function init() {
    decorateNav();
    watchBadges();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); });

  (function wait(tries) {
    if (bindPopups()) return;
    if (tries > 300) return;
    window.setTimeout(function () { wait(tries + 1); }, 100);
  })(0);
})();
